import res from './res'

res.add('kk', {
    datePeriod: 'Tөлемдер',
    status: 'мәртебесі'
})
